import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './assets/css/reset.css'
import 'normalize.css'
import './styles.scss'
import './assets/css/iconfont.css'
import './assets/css/iconfont.js'
import MenuList from './components/menu/index'
import ScrollWrap from './components/scroll/index'
import Print from 'vue-print-nb'

Vue.use(Print)
Vue.use(ElementUI)
Vue.use(MenuList)
Vue.use(ScrollWrap)

Vue.config.productionTip = false

Date.prototype.$Format = function (fmt,American) { //author: meizz
    if(American === true){
        new RegExp(/(.+)\sGMT/).exec(this)
        return RegExp.$1
    }
    let o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

Vue.prototype.$formatNum = function(f,digit){
    let m = Math.pow(10,digit);
    return Math.round(f*m,10)/m
}

Vue.prototype.$getBarWidth = function getBarWidth() {
    let outDiv = document.createElement("div");
    outDiv.style.width = "100px";
    outDiv.style.position = "absolute";
    outDiv.style.top = "-9999px";
    document.body.appendChild(outDiv);
    let widthnobar = outDiv.offsetWidth;
    
    outDiv.style.overflow = "scroll";
    
    let innerDiv = document.createElement("div");
    innerDiv.style.width = "100%";
    outDiv.appendChild(innerDiv);
    let widthbar = innerDiv.offsetWidth;
    
    document.body.removeChild(outDiv);
    
    return widthnobar - widthbar;
}

Vue.prototype.$initObj = function init(obj){
    for(let i=0;i<obj.length;i++){
        obj[i] = ''
    }
    return obj;
}
Vue.prototype.$formsetObj = function $formset(target,source){
    for(let i=0;i<target.length;i++){
        target[i] = source[i]
    }
}
if(process.env.NODE_ENV ===  "development" ){
    window.axios.post('/login/logout',{}).then(()=>{
        window.axios.post('/login/process',{user:'100764',password:'12345678'}).then(res=>{
            store.commit('setData',{dataKey:'user',value:res.user})
        })
    })
    
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
